import React, { useCallback, useEffect, useState } from "react";
import { get } from "../../../../services/apiService";
import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  IconButton,
  List,
  ListItem,
  Typography,
} from "@mui/material";
import parse from "html-react-parser";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import CloseIcon from "@mui/icons-material/Close";

const Dashboard = ({ children, routes }) => {
  const userId = sessionStorage.getItem("userId");
  const [isLoading, setIsLoading] = useState(false);
  const [pageHtml, setPageHtml] = useState("");
  const previewMode = useSelector((state) => state.previewMode);
  const { t } = useTranslation();
  const currentLanguage = i18next.language;
  const [userInfo, setUserInfo] = useState(null);
  const [disclaimerVisible, setDisclaimerVisible] = useState(true);

  const onLoading = (isLoading) => {
    setIsLoading(isLoading);
  };

  // Wrap getHtmlForAllSections in useCallback to memoize it
  const getHtmlForAllSections = useCallback(async () => {
    if (userId) {
      const response = await get(
        `users/${userId}/website-html/${currentLanguage}`,
        {},
        onLoading
      );
      console.log("html response----------->", response);
      setPageHtml(response?.data);
    }
  }, [userId, currentLanguage]); // Add dependencies here

  useEffect(() => {
    getHtmlForAllSections();
    console.log("preview mode------->", previewMode);
  }, [getHtmlForAllSections, previewMode]); // Include getHtmlForAllSections in dependencies

  const transform = (node) => {
    if (node.attribs && node.attribs.class) {
      node.attribs.class = node.attribs.class.replace("container", "px-2");
      node.attribs.class = node.attribs.class.replace(
        "max-w-[1600px]",
        "mx-auto"
      );
    }
    return node;
  };

  const fetchUserDetails = useCallback(async () => {
    if (userId) {
      const response = await get(`users/${userId}`, {}, onLoading);
      if (response?.status === 200) {
        const user = response.data || "#E3E3E3";
        console.log("user object-------->", user);
        setUserInfo(user);
      }
    }
  }, [userId]);

  useEffect(() => {
    fetchUserDetails();
  }, [fetchUserDetails]);

  return (
    <div>
      {/* Domain Guidelines */}
      {userInfo?.domain?.domainName?.length > 0 && disclaimerVisible && (
        <Card
          sx={{
            boxShadow: 3,
            borderRadius: 2,
            backgroundColor: "#f9f9f9",
            p: 2,
            mt: 3,
            mb: 3,
            position: "relative",
          }}
        >
          {/* Close Icon */}
          <IconButton
            size="small"
            onClick={() => setDisclaimerVisible(false)}
            sx={{ 
              position: "absolute", 
              top: 8, 
              right: i18next.language === "en" && 8, 
              left: i18next.language === "ar" && 8
            }}
          >
            <CloseIcon />
          </IconButton>

          <CardContent>
            <Box>
              <Typography
                variant="h6"
                sx={{
                  fontSize: "18px",
                  fontWeight: "bold",
                  mb: 1,
                  color: "#333",
                }}
              >
                {i18next.t("Note")}
              </Typography>

              <Typography sx={{ fontSize: "16px", color: "grey", mb: 2 }}>
                {i18next.t("DISCLAIMER_TEXT")}:
              </Typography>

              <List
                sx={{
                  pl: 2,
                  textAlign: i18next.language === "ar" ? "right" : "left",
                  fontSize: "18px",
                  fontFamily: "Tajawal-Regular"
                }}
              >
                <ListItem sx={{ 
                  display: "list-item", 
                  pl: 2, 
                  fontWeight: 700,
                  flexDirection: i18next.language === "ar" ? "row-reverse" : "row",
                  textAlign: i18next.language === "ar" ? "right" : "left"
                }}>
                  {i18next.t("DISCLAIMER_NEW_PURCHASED_DOMAIN_INFO")}{" "}
                  {userInfo?.email}.{" "}
                  {i18next.t("DISCLAIMER_MICROBAND_EMAIL_INFO")}
                </ListItem>
                <ListItem sx={{ 
                  display: "list-item", 
                  pl: 2, 
                  fontWeight: 700,
                  flexDirection: i18next.language === "ar" ? "row-reverse" : "row",
                  textAlign: i18next.language === "ar" ? "right" : "left" 
                }}>
                  {i18next.t("DISCLAIMER_MICROBAND_INFO")}
                </ListItem>
                <ListItem sx={{ 
                  display: "list-item", 
                  pl: 2, 
                  fontWeight: 700,
                  flexDirection: i18next.language === "ar" ? "row-reverse" : "row",
                  textAlign: i18next.language === "ar" ? "right" : "left" 
                }}>
                  {i18next.t("DISCLAIMER_THIRD_PARTY_DOMAIN_INFO")}
                </ListItem>
              </List>
            </Box>
          </CardContent>
        </Card>
      )}

      {isLoading && <CircularProgress />}
      {pageHtml?.length > 0 && previewMode ? (
        parse(pageHtml)
      ) : pageHtml?.length > 0 && !previewMode ? (
        parse(pageHtml, { replace: transform })
      ) : (
        <div>{t("No Content Found")}</div>
      )}
    </div>
  );
};

export default Dashboard;